import DataPasien from "@/services/DataPasien";
import { IdentitasPasien } from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import PasienNew from "@/services/PasienNew";
import SkriningStore from "./new/SkriningStore";
import Skrining from "@/services/new/Skrining";
import PasienNote from "@/services/new/PasienNote";

interface Pasien {
  rm: number;
  nama: string;
  tgl_lahir: string;
  // usia: Array<any>;
  usia: any;
  jk: string;
  alamat: string;
  alergi: string | null;
}

interface RegisterPasien {
  register_id: number;
  pasien: Pasien;
}
interface PasienState {
  pasien: IdentitasPasien;
}

interface PasienNote {
  id: number;
  note: string;
}

let actPasienToken = 0;

@Module({ store, dynamic: true, name: "storePasien" })
class StorePasien extends VuexModule {
  public pasien = null as Pasien;
  public registerPasien = null as RegisterPasien;
  public identitasPasien = null as IdentitasPasien;
  public note: PasienNote[] = [];
  public loadingPasienTag = false as boolean;

  public cariPasien: Pasien[] = [];

  get hasSkriningBatuk(): boolean {
    return (
      this.identitasPasien?.skrining.filter(
        item => item.category === "batuk" && item.content?.value == "1"
      ).length > 0
    );
  }

  get isTagRegHF() {
    return (
      this.identitasPasien?.tag.filter(tag => tag.name === "reg-heart-failure")
        .length > 0
    );
  }

  get pasienTag() {
    return this.identitasPasien?.tag
      .filter(tag => tag.name !== "reg-heart-failure")
      .map(tag => {
        const attr =
          this.pasientTagAttribute[tag.name] ||
          this.pasientTagAttribute.default;
        return {
          ...tag,
          ...attr
        };
      });
  }

  get pasientTagAttribute() {
    return {
      tbc: {
        color: "orange",
        icon: "mdi-alert-octagram",
        activeText: "Pasien dengan Riwayat TBC"
      },
      hiv: {
        color: "orange",
        icon: "mdi-alert-octagram",
        activeText: "Pasien dengan Riwayat HIV"
      },
      disability: {
        color: "orange",
        icon: "mdi-alert-octagram",
        activeText: "Pasien Disabilitas dengan Brancart"
      },
      default: {
        color: "orange",
        icon: "mdi-alert-octagram",
        activeText: "Pasien dengan Kondisi Khusus"
      }
    };
  }

  @Mutation
  public SET_PASIEN(data: Pasien): void {
    this.pasien = data;
  }

  @Mutation
  public SET_REGISTER_PASIEN(data: any): void {
    this.registerPasien = {
      register_id: data.register,
      pasien: data.pasien
    };
  }

  @Action({ rawError: true })
  public setPasien(data: any): void {
    this.SET_PASIEN(data);
  }

  @Action({ rawError: true })
  public setRegisterPasien(data: any): void {
    this.SET_REGISTER_PASIEN(data);
  }

  @Mutation SET_IDENTITAS_PASIEN(identitasPasien: IdentitasPasien) {
    this.identitasPasien = identitasPasien;
  }

  @Mutation CLEAR_PASIEN() {
    this.identitasPasien = null;
    this.pasien = null;
    this.note = [];
  }

  @Mutation SET_PASIEN_TAG(tags: { id: number; name: string }[]) {
    this.identitasPasien.tag = tags;
  }

  @Mutation SET_PASIEN_SKRINING(skrining) {
    this.identitasPasien.skrining = skrining;
  }

  @Mutation SET_PASIEN_NOTE(note) {
    this.note = note;
  }

  @Mutation SET_LOADING_PASIEN_TAG(val) {
    this.loadingPasienTag = val;
  }

  @Action({ rawError: true })
  async act_pasien_last_reg(rm) {
    const dt = await DataPasien.getDataPasienLastReg(rm);

    // tambahin tag buat placeholder var tag
    this.SET_IDENTITAS_PASIEN({ ...dt.data[0], tag: [], skrining: [] });

    this.SET_REGISTER_PASIEN({
      register: dt.data[0].register?.no,
      pasien: dt.data[0]
    });

    await this.getPasienTag();

    await this.getSkriningByReg();
  }

  @Action({ rawError: true }) async act_pasien(rm) {
    const token = ++actPasienToken;
    const dt = await DataPasien.getDataPasien(rm);
    if (token !== actPasienToken) return;

    const px = dt.data[0];

    // tambahin tag buat placeholder var tag
    this.SET_IDENTITAS_PASIEN({ ...px, tag: [], skrining: [] });

    await this.getPasienTag();
    if (token !== actPasienToken) return;

    await this.getSkriningByReg();
  }

  @Action({ rawError: true }) async getDataPasien(rm) {
    const dt = await DataPasien.getDataPasien(rm);

    const px = dt.data[0];

    // tambahin tag buat placeholder var tag
    this.SET_IDENTITAS_PASIEN({ ...px, tag: [], skrining: [] });

    await this.getPasienTag();

    await this.getSkriningByReg();
  }

  @Action({ rawError: true })
  public async getPasienTag() {
    const rm = this.identitasPasien.rm;
    this.SET_LOADING_PASIEN_TAG(true);

    const resp = await PasienNew.getPasienTag(rm).finally(() => {
      this.SET_LOADING_PASIEN_TAG(false);
    });
    if (this.identitasPasien?.rm !== rm) return;

    this.SET_PASIEN_TAG(resp);
  }

  @Action({ rawError: true })
  public async getSkriningByReg() {
    const rm = this.identitasPasien?.rm;
    const resp = await Skrining.getSkriningByReg(
      this.registerPasien?.register_id
    );
    if (!this.identitasPasien || this.identitasPasien.rm !== rm) return;

    this.SET_PASIEN_SKRINING(resp);
  }

  @Action({ rawError: true })
  public clear() {
    this.CLEAR_PASIEN();
  }

  @Action({ rawError: true })
  public async getPasienNote(rm = null) {
    const resp = await PasienNote.getNote(rm ?? this.identitasPasien.rm);

    this.SET_PASIEN_NOTE(resp.data);
  }
}

export const storePasien = getModule(StorePasien);
